export default __webpack_public_path__ + "static/media/icons-close.1f19bb3d.svg";